module.exports = __webpack_public_path__ + "img/no-data.4c06aae6.png";